import { GazetteerService } from './atlas-gazetteer.service';

export const services = [GazetteerService];
